import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import {
  emailRegex,
  nameRegex,
  passwordRegex,
  pathTemplateRegex,
} from './regex'

export const useValidations = () => {
  const { t } = useTranslation()

  return useMemo(
    () => ({
      required: {
        required: t('validations.required'),
      },

      email: {
        pattern: {
          value: emailRegex,
          message: t('validations.invalid_email'),
        },
      },

      fullName: {
        validate: (value: string) => {
          if (!nameRegex.test(value.trim())) {
            return t('validations.invalid_full_name')
          }

          return true
        },
      },

      password: {
        pattern: {
          value: passwordRegex,
          message: t('validations.invalid_password'),
        },
      },

      pathTemplate: {
        pattern: {
          value: pathTemplateRegex,
          message: t('validations.path_template_validation'),
        },
      },

      minLength: (
        length: number,
        {
          trim = true,
          allowEmpty = true,
          message,
        }: {
          trim?: boolean
          allowEmpty?: boolean
          message?: string
        } = {},
      ) => {
        return (value: string) => {
          if (value === '' && allowEmpty) {
            return true
          }

          const text = trim ? value.trim() : value

          return (
            text.length >= length ||
            message ||
            t('validations.min_length', { minLength: length })
          )
        }
      },

      maxLength: (
        length: number,
        { trim = true, message }: { trim?: boolean; message?: string } = {},
      ) => {
        return (value: string) => {
          const text = trim ? value.trim() : value
          return (
            text.length <= length ||
            message ||
            t('validations.max_length', { maxLength: length })
          )
        }
      },
    }),
    [t],
  )
}
